// removed by extract-text-webpack-plugin
module.exports = {"footerContainer":"style__footerContainer__1i8qs","footer":"style__footer__jDhHL","copy":"style__copy__3cYwr","links":"style__links__2-x3e","right":"style__right__1yjcy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/style.scss
// module id = 1093
// module chunks = 0